import axios from 'axios'
import { setLoading, setFinished, setInitial } from './LoadingButton'
import { checkRecaptchaScore } from './Recaptcha'

export default StepsForm

function StepsForm() {
  const form = document.querySelector('.js-steps-form')
  if (!form) return

  const counter = [...document.querySelectorAll('.js-steps-form-counter')]
  const counts = [...document.querySelectorAll('.js-steps-form-count')]
  const steps = [...document.querySelectorAll('.js-steps-form-step')]
  const nextButtons = [...document.querySelectorAll('.js-steps-form-next')]
  const prevButtons = [...document.querySelectorAll('.js-steps-form-prev')]
  const actualForm = document.querySelector('.js-steps-form-form')
  let index = 1

  ;[...nextButtons].forEach(button =>
    button.addEventListener('click', function() {
      counter.forEach(count => {
        count.classList.add('c-steps-form__steps-counter-inner--active')
      })
      const inputs = steps[index - 1].querySelectorAll('input,textarea,select')
      let valid = true
      ;[...inputs].forEach(input => {
        if (input.validity.valid === false && valid !== false) {
          valid = false
        }
      })
      if (valid) {
        index++
        showNewItem(counts, index, 'c-steps-form__count--active')
        showNewItem(steps, index, 'c-steps-form-step--active')
      }
    })
  )

  if (actualForm) {
    checkRecaptchaScore(form)
    actualForm.addEventListener('submit', sendForm)
  }

  counts.forEach(count => {
    count.addEventListener('click', e => {
      counter.forEach(element => {
        element.classList.add('c-steps-form__steps-counter-inner--active')
      })
      if (e.target.dataset.index > index) {
        const inputs = steps[index - 1].querySelectorAll('input')
        let valid = true
        ;[...inputs].forEach(input => {
          if (input.validity.valid === false && valid !== false) {
            valid = false
          }
        })
        if (valid) {
          index = Number(e.target.dataset.index)
          showNewItem(counts, index, 'c-steps-form__count--active')
          showNewItem(steps, index, 'c-steps-form-step--active')
        }
      } else if (e.target.dataset.index != index) {
        index = Number(e.target.dataset.index)
        showNewItem(counts, index, 'c-steps-form__count--active')
        showNewItem(steps, index, 'c-steps-form-step--active')
      }
    })
  })

  ;[...prevButtons].forEach(button =>
    button.addEventListener('click', function() {
      index--
      showNewItem(counts, index, 'c-steps-form__count--active')
      showNewItem(steps, index, 'c-steps-form-step--active')
    })
  )

  function showNewItem(items, index, className) {
    ;[...items].forEach(item => {
      if (index === parseInt(item.dataset.index)) {
        item.classList.add(className)
      } else {
        item.classList.remove(className)
      }
    })
  }

  function sendForm(e) {
    e.preventDefault()
    const innerForm = this
    const fd = new window.FormData(innerForm)
    const button = form.querySelector('.js-steps-form-send')

    // Set button to loading
    setLoading(button)
    axios({
      method: 'post',
      url: `/wordpress/wp-admin/admin-ajax.php?action=send_form`,
      data: fd,
      params: {
        data: form.action
      }
    })
      .then(r => {
        setFinished(button)
        sendGTAEvent(innerForm)
        setTimeout(() => {
          setInitial(button)
          console.log('form send')
        }, 2000)
        lastStep(form)
        clearForm(innerForm)
      })
      .catch(e => {
        setInitial(button)
      })
  }

  function sendGTAEvent(form) {

    let typeBrochure = 'Onbekend'
    let types = form.querySelectorAll("input[name='typebrochure']") //radio

    ;[...types].forEach(type => { 
      if (type.checked) { 
        typeBrochure = type.value
      }  
    })

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'formSent',
      form:
        form.querySelector("input[name='form_title']") !== undefined &&
        form.querySelector("input[name='form_title']") !== null
          ? form.querySelector("input[name='form_title']").value
          : 'Onbekend',
      product_referral:
        form.querySelector("input[name='product_referral']") !== undefined &&
        form.querySelector("input[name='product_referral']") !== null
          ? form.querySelector("input[name='product_referral']").value
          : 'Onbekend',
      type_brochure: typeBrochure
    })
  }

  function lastStep(form) {
    const confirmation = document.querySelector('.js-steps-form-confirmation')
    const intro = document.querySelectorAll('.js-steps-form-intro-text')
    if (confirmation) {
      form.parentNode.removeChild(form)
      confirmation.classList.add('c-steps-form-confirmation--active')
      ;[...intro].forEach(element => {
        element.parentNode.removeChild(element)
      })
    }
  }

  const clearForm = form => {
    form.reset()
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/StepsForm.js